import React, { useContext } from "react";
import { Alert, Platform, TouchableOpacity, View } from "react-native";
import { Text } from "react-native-elements";
import { Item } from "../../lib/types/product/item";
import { elevationShadowStyle } from "../../lib/utils/elevationShadowStyle";
import { RootStoreContext } from "../../stores/RootStore";
import { TpIconCog, TpIconTrash } from "../Icon";
import Icon from "../Icon/Icon";

interface Props {
  item: Item;
}
const PointOfSaleItemsListItem = ({ item }) => {
  const { pointOfSaleStore } = useContext(RootStoreContext);
  return (
    <View
      key={`item-list-item-${item.id}`}
      style={{
        justifyContent: "space-between",
        flexDirection: "row",
        marginBottom: 8
      }}
    >
      <View
        style={{
          backgroundColor: "#fff",
          paddingHorizontal: 15,
          paddingVertical: 10,
          borderRadius: 8,
          width: "70%",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "row",
          ...elevationShadowStyle(10)
        }}
      >
        <Icon name={item.icon} size={40} />
        <View
          style={{
            marginHorizontal: 10,
            flexGrow: 1
          }}
        >
          <Text style={{ fontSize: 13, lineHeight: 12, marginBottom: 3 }}>
            {item.description}
          </Text>
          {item.openPrice ? (
            <Text style={{ fontSize: 11, lineHeight: 12 }}>
              Rörligt pris
              {item.categories &&
                item.categories.length > 0 &&
                `, Kategori: ${item.categories[0].name}`}
            </Text>
          ) : (
            <Text style={{ fontSize: 11, lineHeight: 12 }}>
              {`${item.priceInclVat} kr`}
              {item.categories &&
                item.categories.length > 0 &&
                `, Kategori: ${item.categories[0].name}`}
            </Text>
          )}
        </View>
        <TpIconCog size={20} color="rgba(0,0,0,0.3)" />
      </View>
      <View
        style={{
          width: "30%",
          justifyContent: "center",
          alignItems: "flex-end"
        }}
      >
        <TouchableOpacity
          style={{
            justifyContent: "center",
            // backgroundColor: "rgba(0,255,0,0.4)",
            height: 40
          }}
          onPress={() => {
            // console.log("Delete clicked!");
            if (Platform.OS === "web") {
              if (
                confirm(
                  `Vill du verkligen ta bort produkten ${item.description}?`
                )
              ) {
                pointOfSaleStore._deleteItem(item.id);
              } else {
                // console.log("Cancel Pressed");
              }
            } else {
              Alert.alert(
                "Är du säker?",
                `Vill du verkligen ta bort produkten ${item.description}?`,
                [
                  {
                    text: "Avbryt",
                    onPress: () => console.log("Cancel Pressed"),
                    style: "cancel"
                  },
                  {
                    text: "Ta bort",
                    onPress: () => pointOfSaleStore._deleteItem(item.id)
                  }
                ],
                { cancelable: false }
              );
            }
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <TpIconTrash color="rgba(0,0,0,0.3)" style={{ marginRight: 5 }} />
            <Text
              style={{
                color: "rgba(0,0,0,0.3)",
                fontSize: 11,
                fontWeight: "bold"
              }}
            >
              RADERA
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default PointOfSaleItemsListItem;
